import { replace } from 'ramda';

import { type DatoCmaLocale } from '@/lib/datocms/cma/types';
import { type DatoLocale } from '@/lib/datocms/types';
import { type Language, regionMainLanguage } from '@/lib/utils/language';
import { type Region } from '@/types';

export const urlToDatoLocale: Record<string, DatoLocale> = {
  dede: 'de_DE',
  deen: 'en_US',
  esen: 'en_US',
  eses: 'es_ES',
  fren: 'en_US',
  frfr: 'fr_FR',
  nlen: 'en_US',
  nlnl: 'nl_NL',
  pten: 'en_US',
  ptpt: 'pt_PT',
  uken: 'en_GB',
  usen: 'en_US',
  uses: 'es_ES',
  wwen: 'en_US',
} as const satisfies Partial<Record<`${Region}${Language}`, DatoLocale>>;

export const getMainLocaleForRegion = (region: Region): DatoLocale => {
  const mainLanguage = regionMainLanguage[region];
  const locale = urlToDatoLocale[`${region}${mainLanguage}`];
  return locale;
};

export const toStandardLocale = replace('_', '-') as (
  locale: DatoLocale
) => DatoCmaLocale;
